export function formatDate(d: Date): string {
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** Monday-Friday of the week before the one containing `now`. */
export function previousWorkWeek(now: Date = new Date()): {
  startDate: string;
  endDate: string;
} {
  const daysSinceMonday = (now.getDay() + 6) % 7;
  const monday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  monday.setDate(monday.getDate() - daysSinceMonday - 7);
  const friday = new Date(monday);
  friday.setDate(monday.getDate() + 4);
  return { startDate: formatDate(monday), endDate: formatDate(friday) };
}

export function isValidRange(start: string, end: string): boolean {
  const iso = /^\d{4}-\d{2}-\d{2}$/;
  return iso.test(start) && iso.test(end) && start <= end;
}

export function formatDateTime(value: string | null | undefined): string {
  return value ? new Date(value).toLocaleString() : "—";
}
